__turbopack_context__.v({
  "resource": "resource-module-scss-module__qefoZq__resource",
  "resourceContent": "resource-module-scss-module__qefoZq__resourceContent",
  "resourceContentBody": "resource-module-scss-module__qefoZq__resourceContentBody",
  "resourceHeader": "resource-module-scss-module__qefoZq__resourceHeader",
  "resourceHeaderImage": "resource-module-scss-module__qefoZq__resourceHeaderImage",
  "resourceHeaderTitle": "resource-module-scss-module__qefoZq__resourceHeaderTitle",
  "resourceTableOfContents": "resource-module-scss-module__qefoZq__resourceTableOfContents",
  "resourceTableOfContentsList": "resource-module-scss-module__qefoZq__resourceTableOfContentsList",
  "resourceTableOfContentsListItem": "resource-module-scss-module__qefoZq__resourceTableOfContentsListItem",
  "resourceTableOfContentsTitle": "resource-module-scss-module__qefoZq__resourceTableOfContentsTitle",
  "richText": "resource-module-scss-module__qefoZq__richText",
});
